module.exports = __webpack_public_path__ + "img/icon_checkbox_off.8f11e1b7.svg";